import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetLoyaltyBalanceQuery } from '../loyaltyApi';

interface Props {
  restaurantUuid: string;
  /** The drawer's own row classes, so the entry reads like its neighbours. */
  className: string;
  onNavigate: () => void;
}

/**
 * SC-1091 M6 — « Ma carte fidélité » in the site menu: the QR was two taps and a
 * scroll away (Compte, past Profil / Commandes / Adresses). Mounted for logged-in
 * customers only; renders nothing unless the restaurant runs a loyalty program.
 */
export default function LoyaltyMenuLink({ restaurantUuid, className, onNavigate }: Props) {
  const { t } = useTranslation();
  const { data } = useGetLoyaltyBalanceQuery(restaurantUuid, { skip: !restaurantUuid });
  if (!data?.enabled) return null;
  return (
    <Link
      to={`/${restaurantUuid}/account/loyalty`}
      onClick={onNavigate}
      data-testid="menu-loyalty-link"
      className={className}
    >
      <span aria-hidden="true">🎁</span>
      <span>{t('loyalty.menuEntry')}</span>
    </Link>
  );
}
